import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlAutomaticPayment} from "../getAutomaticPayment.api";
import {AutomaticPayment} from "../../../graphql/payments.datatypes";
import {updateCacheByType} from "../../../graphql/GraphQlProvider";

interface DeleteAutomaticPaymentInput {
    id: number
}

interface DeleteAutomaticPaymentData {
    deleteAutomaticPayment: AutomaticPayment
}

export const DELETE_AUTOMATIC_PAYMENT_MUTATION = gql`
    mutation deleteAutomaticPayment($id: Int!) {
        deleteAutomaticPayment(id: $id) {
            ${gqlAutomaticPayment}
        }
    }
`;

export const deleteAutomaticPayment = () => useMutation<DeleteAutomaticPaymentData, DeleteAutomaticPaymentInput>(
    DELETE_AUTOMATIC_PAYMENT_MUTATION,
    {
        update: updateCacheByType('BillingParty'),
    }
);

export default deleteAutomaticPayment;
